import React from 'react';
import _ from 'lodash';

import { Checkbox } from '@mui/material';
import { BaseWidget } from 'modules/layer01';
import { Table } from 'iron-forge-react-modules';
import { currencyUtil } from 'modules/layer00';
import * as types from './types';
import * as dataService from './dataService';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export interface IProps {
  variant?: 'customer' | 'partner';
  returnAuthorizationId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId, props.variant === 'customer');

  const rows = React.useMemo(
    () => _.map(queryTuple.data.lineItems, (row): types.IRow => ({
      id: row.id,
      columnId2Value: {
        price: {
          type: 'string',
          label: currencyUtil.convertBigCentsToDollars(row.refundAmountCents)
        },
        productName: {
          type: 'string',
          label: row.productName
        },
        sku: {
          type: 'string',
          label: row.sku
        },
        quantity: {
          type: 'string',
          label: row.quantity.toString()
        },
        reasonForReturn: {
          type: 'string',
          label: row.reasonForReturn
        },
        received: {
          type: 'component',
          sortableValue: 0,
          label: (
            <Checkbox
              disabled
              checked={row.isReceived} />
          )
        }
      }
    })),
    [queryTuple.data.lineItems]
  );

  return (
    <BaseWidget.FC title="Returned Products">
      <TableComponent
        disableClientSorting
        disableSorting
        rows={rows}
        columns={[
          {
            id: 'productName',
            label: "Product"
          },
          {
            id: 'sku',
            label: "SKU"
          },
          {
            id: 'reasonForReturn',
            label: "Reason for Return"
          },
          {
            id: 'quantity',
            label: "Quantity"
          },
          {
            id: 'price',
            show: props.variant !== 'customer',
            label: "Price"
          }
        ]} />
    </BaseWidget.FC>
  );
};
